import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from './pages/Login';
import InformesList from './components/InformesList';
import InformeLayout from './components/InformeLayout';
import SalaCliente from './components/phases/SalaCliente';
import Layout from './components/Layout';
import GlobalToast from './components/GlobalToast';
import ConfiguracionPage from './components/ConfiguracionPage';
import { User } from './types';
import './App.css';

const App: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');

        if (token && savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (error) {
                console.error('Error al parsear usuario guardado:', error);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        }
        setLoading(false);
    }, []);

    const prvHandleLoginSuccess = (userData: User) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    const prvHandleLogout = () => {
        setUser(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    };

    if (loading) {
        return <div className="loading-screen">Cargando...</div>;
    }

    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '419835509270-a4foq0nf8rmm2ovpo4b0j7q7d723qv54.apps.googleusercontent.com';

    console.log('Google Client ID being used:', googleClientId);
    console.log('Frontend URL:', window.location.origin);

    return (
        <GoogleOAuthProvider clientId={googleClientId}>
            <GlobalToast />
            <Router>
                <Routes>
                    <Route
                        path="/login"
                        element={!user ? <Login onLoginSuccess={prvHandleLoginSuccess} /> : <Navigate to="/" />}
                    />
                    <Route path="/sala-cliente" element={<SalaCliente />} />
                    <Route
                        path="/"
                        element={
                            user ? (
                                <Layout user={user} onLogout={prvHandleLogout}>
                                    <InformesList user={user} />
                                </Layout>
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    />
                    <Route
                        path="/configuracion"
                        element={
                            user ? (
                                <Layout user={user} onLogout={prvHandleLogout}>
                                    <ConfiguracionPage />
                                </Layout>
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    />
                    <Route
                        path="/informes/:id/:fase"
                        element={
                            user ? (
                                <Layout user={user} onLogout={prvHandleLogout}>
                                    <InformeLayout />
                                </Layout>
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    />
                    <Route path="/create" element={<Navigate to="/informes/new/encargo" />} />
                    <Route path="/edit/:id" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </GoogleOAuthProvider>
    );
};

export default App;
